// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+Dv3Y"};